var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.4917 18.19H25.7438C23.4904 18.19 21.6553 16.26 21.6553 13.89V11C21.6553 10.45 21.2274 10 20.7045 10H16.673C13.7445 10 11.377 12 11.377 15.57V24.43C11.377 28 13.7445 30 16.673 30H24.1465C27.075 30 29.4425 28 29.4425 24.43V19.19C29.4425 18.64 29.0147 18.19 28.4917 18.19Z",
    fill: "#FA8443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0229 10.21C23.6331 9.79999 22.958 10.08 22.958 10.65V14.14C22.958 15.6 24.137 16.81 25.5728 16.81C26.476 16.82 27.7311 16.82 28.8055 16.82C29.3475 16.82 29.6328 16.15 29.2524 15.75C27.8833 14.3 25.4301 11.69 24.0229 10.21Z",
    fill: "#FA8443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.836 21.75H16.1311C15.7412 21.75 15.418 21.41 15.418 21C15.418 20.59 15.7412 20.25 16.1311 20.25H21.836C22.2258 20.25 22.5491 20.59 22.5491 21C22.5491 21.41 22.2258 21.75 21.836 21.75Z",
    fill: "#FA8443"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9344 25.75H16.1311C15.7412 25.75 15.418 25.41 15.418 25C15.418 24.59 15.7412 24.25 16.1311 24.25H19.9344C20.3242 24.25 20.6475 24.59 20.6475 25C20.6475 25.41 20.3242 25.75 19.9344 25.75Z",
    fill: "#FA8443"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.c7ffc5a30e55ce8833a4e56407ffcd07.svg";
export { ForwardRef as ReactComponent };